import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eaaf76a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "not-found c-secondary"
}

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import Album from '../albums/Album.vue';
import TextAlbum from './TextAlbum.vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data: MovieAlbum[]
}


const store = useStore()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const container = ref<HTMLDivElement>()
const offset = ref(5)

const list1 = computed(() => props.data.slice(0, offset.value))
const list2 = computed(() => props.data.slice(offset.value))

onMounted(() => {
    window.onresize = onResize;
    onResize();
})

onBeforeUnmount(() => {
    window.onresize = null
})

function onResize() {
    let rect = container.value?.getBoundingClientRect() as DOMRect;
    if (rect.width > 0) {
        offset.value = Math.floor((rect.width + 20) / 170)
    } else {
        offset.value = 5
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "albums",
      ref_key: "container",
      ref: container
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list1), (item) => {
        return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
      }), 256))
    ], 512),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list2), (item, i) => {
        return (_openBlock(), _createBlock(TextAlbum, {
          album: item,
          i: i + offset.value + 1
        }, null, 8, ["album", "i"]))
      }), 256))
    ]),
    (__props.data.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(lang).movieText.empty), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})